import { render } from "./ggjxgrycgbd.vue?vue&type=template&id=dbb7761a&scoped=true&ts=true"
import script from "./ggjxgrycgbd.vue?vue&type=script&lang=ts"
export * from "./ggjxgrycgbd.vue?vue&type=script&lang=ts"

import "./ggjxgrycgbd.vue?vue&type=style&index=0&id=dbb7761a&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb7761a"]])

export default __exports__